<script setup>
import EnWarningIcon from 'Components/icons/EnWarningIcon.vue';

const props = defineProps({
  error: {
    type: String,
    required: true,
  },
});

</script>

<template>
    <span class="validation-error">
      <en-warning-icon class="warning-icon"></en-warning-icon> 
      <span>{{ error }}</span>
    </span>
</template>

<style scoped lang="scss">
@use "Styles/helper/variables.scss";

.validation-error {
  font-weight: 400;
  font-size: 14.46px;
  text-decoration: none;
  color: variables.$en-red;
  display: flex;
  
  .warning-icon {
    width: 25px;
    margin: auto 2px;
  }
}
</style>